export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Adds the anti-CSRF header required by the backend on every request to our own API.
export const installApiGuard = () => {
  const original = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";
    if (url.startsWith(API) || url.startsWith("/api")) {
      const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
      headers.set("X-Requested-With", "LUIZ.DEV");
      init = { ...init, headers };
    }
    return original(input, init);
  };
};

export const formatApiErrorDetail = (detail, fallback = "Algo deu errado. Tente novamente.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || fallback;
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
};

export const readError = async (res, fallback) => {
  try {
    const data = await res.json();
    return formatApiErrorDetail(data.detail, fallback);
  } catch {
    return fallback;
  }
};
